module.exports = __webpack_public_path__ + "assets/img/solar-panel.b98f2d8e.jpg";